import React, { FC, useState, useEffect } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css?raw";
import "slick-carousel/slick/slick-theme.css?raw";
import ISlickCarousel from "src/app/data/client/interfaces/ISlickCarousel";
import RestService from 'src/app/services/rest/RestService';
import LazyImage from 'src/components/LazyImage';
import styles from './SlickCarousel.css';

interface IProps {
  images?: string[];
  alt?: string;
  id?: string;
  settings?: ISlickCarousel;
}

const SlickCarousel: FC<IProps> = (props) => {
  const [imageDOM, setImageDOM] = useState<any>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const { images = [], alt, id, settings } = props;

  const fetchImageAPIResponse = async () => {
    const promises = images.map(image => fetch(`${RestService.GET_PUBLIC_URL}${image}`));
    try {
      const res = await Promise.all(promises);
      const data = res.map((result) => result);
      if(data.every(item => item.status === 200)){
        setImageDOM(data);
      }
    } catch {
      throw Error("Promise failed");
    }
  };

  useEffect(() => {
    fetchImageAPIResponse();
  }, []);

  const fetchLoadingResponse = (flag: boolean) => {
    setLoading(flag);
  };
  const getImageSourceUrl = (item: any) => {
    if(item?.url){
      return item?.url;
    }
    return '';
  };

  if(!loading) {
    return <LazyImage src={images[0]} fetchLoadingResponse={fetchLoadingResponse} />;
  }
    return (
      <div className={styles.imageWrapperCircle} id={id}>
        <Slider {...settings}>
          {imageDOM && imageDOM.length ? (
            imageDOM.map((src: any, index: number) => <div key={`avatar-${index}`}> <img src={getImageSourceUrl(src)} alt={alt} /> </div>)
          ): null}
        </Slider>
      </div>
    );
};
export default SlickCarousel;